export default __webpack_public_path__ + "static/media/home-active.39ab444d.svg";